import template from './bannerMessage.html';
import controller from './bannerMessage.controller';

let bannerMessageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default bannerMessageComponent;



// WEBPACK FOOTER //
// ./app/common/bannerMessage/bannerMessage.component.js